import type { CSSProperties, FC, ReactNode } from 'react'

import Image from 'next/image'

import { partners } from '@/constants/metric'
import { SectionHeading } from '@/components/generals/section-heading'

const track = [...partners, ...partners]

export const PartnersSection: FC = (): ReactNode => {
    return (
        <section id='partners' aria-labelledby='partners-title' className='scroll-mt-[96px] px-0 py-20 tab:px-[60px] tab:py-28'>
            <div className='fw-container flex flex-col items-center gap-12 tab:gap-16'>
                <SectionHeading
                    tag='Partners'
                    title={<span id='partners-title'>In partnership with</span>}
                    description='The companies and teams making Metric possible.'
                />
            </div>

            <div
                data-reveal='up'
                className='relative mt-4 w-full overflow-hidden'
                style={{
                    maskImage: 'linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)',
                    WebkitMaskImage: 'linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)'
                }}
                onMouseEnter={(e) => e.currentTarget.style.setProperty('--ticker-state', 'paused')}
                onMouseLeave={(e) => e.currentTarget.style.setProperty('--ticker-state', 'running')}
            >
                <ul
                    className='fw-ticker-track flex w-max items-center gap-5'
                    style={{ '--ticker-duration': '38s' } as CSSProperties}
                >
                    {track.map((logo, index) => (
                        <li
                            key={`${logo}-${index}`}
                            aria-hidden={index >= partners.length}
                            className='flex h-[92px] w-[196px] shrink-0 items-center justify-center rounded-[9px] border border-line bg-surface px-8 transition-colors duration-500 hover:border-[#454545]'
                        >
                            <span className='relative block h-[30px] w-full opacity-70 transition-opacity duration-500 hover:opacity-100'>
                                <Image
                                    src={logo}
                                    alt=''
                                    fill
                                    sizes='140px'
                                    className='object-contain'
                                />
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
